import React, { useEffect, useState } from 'react';
import LoadingBar from './loadingBar';
import LoginLoader from './loginLoader';
const Loader = ({
  router,
  login
}) => {
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const handleStart = () => {
      setIsLoading(true);
    };
    const handleStop = () => {
      setIsLoading(false);
    };
    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleStop);
    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleStop);
    };
  }, [router.events]);
  if (!isLoading) return null;
  return <>{login ? <LoginLoader /> : <LoadingBar />}</>;
};
export default Loader;